var map = {
	"./en/2.png": 4048,
	"./en/3.png": 2483,
	"./en/4.png": 2624,
	"./en/5.png": 4177,
	"./en/6.png": 5666,
	"./en/7.png": 8962,
	"./en/8.png": 6947,
	"./en/step2-content-ios.png": 3235,
	"./en/step2-content.png": 8212,
	"./zh/2.png": 7553,
	"./zh/3.png": 5138,
	"./zh/4.png": 9122,
	"./zh/5.png": 1408,
	"./zh/6.png": 7043,
	"./zh/7.png": 1229,
	"./zh/8.png": 2528,
	"./zh/step2-content-ios.png": 9421,
	"./zh/step2-content.png": 5004
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3277;